export const StripeHeight = {
  HEIGHT_4: 4,
  HEIGHT_5: 5,
  HEIGHT_6: 6,
  HEIGHT_24: 24
};